import { Group, Title } from '@mantine/core';
import TableGridToggle, { ViewMode } from './TableGridToggle';
import type { ReactNode } from 'react';

export default function EntityHeader({ title, icon, view, onView }: { title: string; icon?: ReactNode; view: ViewMode; onView: (v: ViewMode) => void }) {
  return (
    <Group justify="space-between" align="center" mb="md">
      <Group gap={10}>
        {icon}
        <Title order={2}>{title}</Title>
      </Group>
      <TableGridToggle value={view} onChange={onView} />
    </Group>
  );
}
